import { Heading } from '@/components/Heading';
import { CloseXButton, Modal } from '@/components/Modal';
import { ProductTileModal } from '@/components/ProductTileModal';
import type { Product } from '@/types';

interface OtherFormatsProps {
  products: Product[];
}

const modalTrigger = { content: 'Other formats', label: 'Other formats' };

export const OtherFormats = ({ products }: OtherFormatsProps) => (
  <span className="product__primary__details__row__detail">
    <Modal isLinkLike={true} trigger={modalTrigger}>
      <Heading level={3} slot="title">
        Other formats & editions:
      </Heading>
      {products.map(product => (
        <ProductTileModal
          key={product.sku}
          product={product}
        />
      ))}
      <CloseXButton className="close-modal" slot="close" />
    </Modal>
  </span>
);
